export const DIRECT_PROFILE_KNOWLEDGE_PERSISTENCE_MODE = 'direct_profile_add';
export const DIRECT_PROFILE_KNOWLEDGE_SOURCE_ITEM_ID = 'explicit-profile-add';
export const PROFILE_ORGANIZATION_MODES = Object.freeze({ SIMPLE: 'simple', COMPLEX: 'complex' });

export const getDirectProfileOrganizationMode = (text = '') => {
  const value = String(text || '').trim();
  const sentenceCount = value.split(/[.!?]+(?:\s+|$)/).filter((part) => part.trim()).length;
  const hasMultipleClauses = /[;\n]|\b(?:and|but|while|because)\b.{12,}/i.test(value);
  return sentenceCount > 1 || hasMultipleClauses
    ? PROFILE_ORGANIZATION_MODES.COMPLEX
    : PROFILE_ORGANIZATION_MODES.SIMPLE;
};

export const isDirectProfileKnowledgeSource = (source = {}) => {
  const persistenceMode = source.knowledgePersistenceMode
    || source.sourceMetadata?.knowledgePersistenceMode
    || source.metadata?.source?.knowledgePersistenceMode;
  return String(persistenceMode || '').trim() === DIRECT_PROFILE_KNOWLEDGE_PERSISTENCE_MODE;
};

export const isComplexDirectProfileKnowledgeSource = (source = {}) => (
  isDirectProfileKnowledgeSource(source)
  && String(source.profileOrganizationMode
    || source.sourceMetadata?.profileOrganizationMode
    || source.metadata?.source?.profileOrganizationMode
    || '').trim() === PROFILE_ORGANIZATION_MODES.COMPLEX
);
